import { useTranslation } from 'react-i18next';
import { useUserContext } from '@/contexts/UserContext';
import { useCurrentUser } from '@/hooks/useCurrentUser';

interface HomeHeroProps {
  pendingCount: number;
}

function getGreetingKey(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'survey.greetingMorning';
  if (hour < 19) return 'survey.greetingAfternoon';
  return 'survey.greetingEvening';
}

export function HomeHero({ pendingCount }: HomeHeroProps) {
  const { t } = useTranslation();
  const { demoUser } = useUserContext();
  const currentUser = useCurrentUser();
  const displayName = currentUser?.givenName|| currentUser?.displayName || demoUser.nombre || t('roles.employee');

  return (
    <div className="home-greeting">
      <div className="home-greeting-left">
        <img
          src="/assets/persona-globo.svg"
          alt=""
          className="home-mascot"
          aria-hidden="true"
        />
        <div>
          <h1 className="home-hello">
            {t(getGreetingKey())}, <span className="sv-hero-name">{displayName}</span>!
          </h1>
          <p className="home-sub">
            {pendingCount > 0 ? (
              <>
                {t('survey.pendingCountPre')}{' '}
                <strong className="sv-hero-count">{pendingCount}</strong>{' '}
                {pendingCount === 1 ? t('survey.pendingCountSingular') : t('survey.pendingCountPlural')}
              </>
            ) : (
              t('survey.allDoneSubtitle')
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
